import { useEffect, useRef, useState } from 'react';

const GALLERY = [
  { src: 'https://public.readdy.ai/ai/img_res/cec58cd8bb833acd20feab2c867d777a.jpg', span: 'row-span-2' },
  { src: 'https://readdy.ai/api/search-image?query=minimalist%20nude%20gel%20nails%20with%20subtle%20chrome%20finish%20on%20slender%20hands%2C%20clean%20white%20background%2C%20luxury%20nail%20studio%2C%20professional%20macro%20photography%2C%20elegant%20and%20modern&width=400&height=300&seq=g2&orientation=landscape', span: '' },
  { src: 'https://readdy.ai/api/search-image?query=bold%203D%20nail%20art%20with%20tiny%20rhinestones%20and%20pearl%20accents%20on%20manicured%20hands%2C%20blush%20pink%20background%2C%20high-end%20nail%20salon%2C%20close-up%20beauty%20photography%2C%20glamorous%20and%20detailed&width=400&height=300&seq=g3&orientation=landscape', span: '' },
  { src: 'https://readdy.ai/api/search-image?query=elegant%20French%20tip%20gel%20nails%20with%20gold%20line%20detail%20on%20feminine%20hands%2C%20soft%20white%20marble%20background%2C%20luxury%20nail%20studio%2C%20professional%20beauty%20photography%2C%20clean%20and%20sophisticated&width=400&height=500&seq=g4&orientation=portrait', span: 'row-span-2' },
  { src: 'https://readdy.ai/api/search-image?query=cat%20eye%20chrome%20gel%20nails%20with%20magnetic%20effect%20on%20elegant%20hands%2C%20dark%20moody%20background%20with%20soft%20lighting%2C%20luxury%20nail%20art%2C%20professional%20close-up%20photography%2C%20futuristic%20and%20premium&width=400&height=300&seq=g5&orientation=landscape', span: '' },
  { src: 'https://readdy.ai/api/search-image?query=hand%20painted%20floral%20nail%20art%20with%20tiny%20roses%20and%20gold%20dots%20on%20gel%20nails%2C%20soft%20blush%20pink%20background%2C%20luxury%20nail%20salon%2C%20macro%20beauty%20photography%2C%20intricate%20and%20feminine&width=400&height=300&seq=g6&orientation=landscape', span: '' },
];

const PRICING = [
  {
    tier: 'Gel-X Extensions',
    highlight: false,
    items: [
      { label: 'Short', price: '$55' },
      { label: 'Medium', price: '$60' },
      { label: 'Long', price: '$65' },
    ],
    note: 'Full set includes shaping, base, color & top coat.',
  },
  {
    tier: 'UV Overlay',
    highlight: false,
    items: [
      { label: 'Full Set', price: '$55' },
    ],
    note: 'Strengthening overlay applied over natural nails for a polished, lasting finish.',
  },
  {
    tier: 'Manicure & Pedicure',
    highlight: false,
    items: [
      { label: 'Manicure — Shellac (base color)', price: '$50' },
      { label: 'Pedicure — Shellac (base color)', price: '$60' },
      { label: 'Manicure & Pedicure — Shellac', price: '$90' },
    ],
    note: 'All services include a base color. Upgrade options available upon request.',
  },
  {
    tier: 'Add-Ons',
    highlight: true,
    items: [
      { label: 'Rhinestones, pearls & gold dots', price: '+$1–3' },
      { label: 'Charms', price: '+$2/nail' },
      { label: 'French tip', price: '+$2/nail or $8 all' },
      { label: 'Hand drawn designs', price: '+$1–5/nail' },
      { label: '3D art', price: '+$2–5/nail' },
      { label: 'Ombré / aura effect', price: '+$2/nail' },
      { label: 'Chrome / cat-eye / glitter', price: '+$2/nail or $8 all' },
      { label: 'Nail Removal', price: '$15' },
      { label: 'Shellac Removal', price: '$8' },
    ],
    note: 'Send a photo of your inspiration for a custom quote.',
  },
];

export default function GalleryPricing() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* Gallery */}
      <section id="gallery" ref={ref} className="bg-white py-24 md:py-32 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <span className="font-sans text-xs tracking-widest2 uppercase text-gold block mb-4">Portfolio</span>
            <h2 className={`font-serif text-4xl md:text-5xl text-ink font-light transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>The Work</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 auto-rows-[200px] md:auto-rows-[220px]">
            {GALLERY.map((img, i) => (
              <div key={i} className={`group overflow-hidden ${img.span} ${visible ? 'opacity-100' : 'opacity-0'} transition-all duration-700`} style={{ transitionDelay: `${i * 100}ms` }}>
                <div className="relative w-full h-full">
                  <img src={img.src} alt={`Nail design ${i + 1}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-500 flex items-center justify-center">
                    <span className="font-sans text-xs tracking-widest uppercase text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">View</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="bg-blush-light py-24 md:py-32 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <span className="font-sans text-xs tracking-widest2 uppercase text-gold block mb-4">Investment</span>
            <h2 className="font-serif text-4xl md:text-5xl text-ink font-light">Pricing</h2>
            <p className="font-sans text-sm text-ink-muted mt-4 max-w-md mx-auto">Transparent pricing. No surprises. Every set is worth it.</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
            {PRICING.map((card, i) => (
              <div key={i} className={`bg-white p-8 md:p-10 border-2 ${card.highlight ? 'border-gold' : 'border-blush-mid'} relative`}>
                {card.highlight && (
                  <span className="absolute -top-3 left-8 bg-gold text-white font-sans text-xs tracking-widest uppercase px-4 py-1">Most Popular</span>
                )}
                <h3 className="font-serif text-2xl text-ink font-medium mb-6">{card.tier}</h3>
                <div className="w-8 h-px bg-gold mb-6" />
                <ul className="space-y-3 mb-8">
                  {card.items.map((item, j) => (
                    <li key={j} className="flex items-center justify-between gap-4">
                      <span className="font-sans text-sm text-ink-soft">{item.label}</span>
                      <span className="font-serif text-base text-gold font-medium whitespace-nowrap">{item.price}</span>
                    </li>
                  ))}
                </ul>
                <p className="font-sans text-xs text-ink-muted italic mb-8 leading-relaxed">{card.note}</p>
                <button
                  onClick={() => window.open('https://calendly.com/lispinruiz/nailappointment', '_blank')}
                  className="whitespace-nowrap w-full font-sans text-sm tracking-widest uppercase py-3.5 border border-gold text-gold hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer"
                >
                  Book Now
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
